import { Component, OnInit, HostBinding, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { CdkDropList, CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ColumnsWithLetter, IDisplayColumn, Order, IColumnType } from './model';
import * as pinyin_ from 'pinyin';
import { MatCheckboxChange, MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
const pinyin = pinyin_;
@Component({
	selector: 'common-view-define',
	templateUrl: './view-define.component.html',
	styleUrls: ['./view-define.component.scss']
})
export class ViewDefineComponent implements OnInit {
	@HostBinding('class.view-define') hostClass = true;
	@Input() readonly: boolean;
	@Input() set AllColumns(val: string[]) {
		this._allColumns = val;
		this.refreshSelectedColumns(this._selectedColumns);
	}
	@Output() ModifyEvent = new EventEmitter<IDisplayColumn[]>();
	_allColumns: string[];
	@ViewChild('leftList', { static: false }) leftList: CdkDropList;
	@ViewChild('rightList', { static: false }) rightList: CdkDropList;
	CanSelectColumns?: ColumnsWithLetter[];
	@Input() set SelectedColumns(val: IDisplayColumn[]) {
		this.refreshSelectedColumns(val);
	}

	_selectedColumns: IDisplayColumn[];
	checkColumns = new Map<string, boolean>();
	readonly orderAsc = Order.OrderAsc;
	readonly orderDesc = Order.OrderDesc;
	readonly orderNone = Order.OrderNone;
	constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
		const icons = [
			'all_chosen',
			'cancel_chosen',
			'return_chosen',
			'single_chosen',
			'double_down',
			'drag_indicator',
			'arrow_collapse',
			'arrow_expand',
			'sorting_arrows',
			'color_add',
			'file_copy',
			'bg_bottom_out'
		];
		icons.forEach(v => {
			iconRegistry.addSvgIcon(
				v,
				sanitizer.bypassSecurityTrustResourceUrl('assets/record-view/icon/' + v + '.svg')
			);
		});
	}

	ngOnInit() {}
	private refreshCanSelectColumns() {
		if (this._allColumns) {
			this.CanSelectColumns = map2WithLetter(
				this._allColumns.filter(
					col => !this._selectedColumns || !this._selectedColumns.find(sel => sel.Name === col)
				)
			);
		}
	}
	private refreshSelectedColumns(cols?: IDisplayColumn[]) {
		this.checkColumns.clear();
		this._selectedColumns = cols;
		this.refreshCanSelectColumns();
	}
	drop(event: CdkDragDrop<string[]>) {
		if (event.container === this.rightList) {
			// å³è¾¹åé¨ç§»å¨
			if (event.previousContainer === event.container) {
				moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
			} else {
				// ä»å·¦è¾¹æå°å³è¾¹
				this._selectedColumns = this._selectedColumns || [];
				this._selectedColumns.splice(event.currentIndex, 0, {
					Name: event.item.data,
					Hidden: false,
					Order: Order.OrderNone
				} as IDisplayColumn);
				this.refreshCanSelectColumns();
			}
		} else if (event.previousContainer !== event.container) {
			// ä»å³è¾¹æå¨å°å·¦è¾¹
			event.previousContainer.data.splice(event.previousIndex, 1);
			this.refreshCanSelectColumns();
		}
		this.emitModify();
	}
	chkSelectChange(event: MatCheckboxChange) {
		if (event.checked) {
			this.checkColumns.set(event.source.value, true);
		} else {
			this.checkColumns.delete(event.source.value);
		}
	}
	toRight(colName: string) {
		this._selectedColumns = this._selectedColumns || [];
		this._selectedColumns.push({
			Name: colName,
			Hidden: false,
			Order: Order.OrderNone
		} as IDisplayColumn);
		this.refreshCanSelectColumns();
		this.emitModify();
	}
	toLeft(idx: number) {
		this._selectedColumns.splice(idx, 1);
		this.refreshCanSelectColumns();
		this.emitModify();
	}
	checkAll(event: MatCheckboxChange) {
		if (event.checked) {
			this.checkColumns.clear();
			this.CanSelectColumns.forEach(item => {
				item.Columns.forEach(node => {
					this.checkColumns.set(node, true);
					// console.log(this.checkColumns.get(node));
				});
			});
		} else {
			this.checkColumns.clear();
		}
	}
	toRightAll() {
		this._selectedColumns = this._selectedColumns || [];
		this.CanSelectColumns.forEach(v => {
			v.Columns.forEach(col => {
				if (this.checkColumns.has(col)) {
					this._selectedColumns.push({
						Name: col,
						Hidden: false,
						Order: Order.OrderNone
					} as IDisplayColumn);
				}
			});
		});
		this.refreshCanSelectColumns();
		this.emitModify();
	}
	acronymFun(letter: string) {
		document.querySelector('#' + letter).scrollIntoView(true);
	}
	emitModify() {
		this.ModifyEvent.emit(this._selectedColumns);
	}
}

function map2WithLetter(v: string[]) {
	const mapList = new Map<string, string[]>();
	v.forEach(vv => {
		let headerLetter = pinyin(vv, { style: pinyin.STYLE_FIRST_LETTER }).map(s => s[0])[0];
		if (headerLetter.length > 1) {
			headerLetter = headerLetter[0];
		}
		if (mapList.has(headerLetter)) {
			mapList.get(headerLetter).push(vv);
		} else {
			mapList.set(headerLetter, [vv]);
		}
	});
	// æåº

	const rev = [] as ColumnsWithLetter[];
	mapList.forEach((columns, letter) => {
		rev.push({ Letter: letter, Columns: columns } as ColumnsWithLetter);
	});
	return rev.sort((a, b) => a.Letter.localeCompare(b.Letter));
}
